import { Button, Stack, Typography, useTheme } from '@mui/material'
import type { FC } from 'react'
import type { UseFormSetValue } from 'react-hook-form'
import { BBoxSelector } from '../BBoxSelector'
import type { CalibrationAreaFormValues } from './formValues'

type Props = {
  labelImageUrl: string
  formValues: CalibrationAreaFormValues
  setValue: UseFormSetValue<CalibrationAreaFormValues>
  canSubmit: boolean
  onSave: () => void
  onClose: () => void
}

export const CalibrationAreaForm: FC<Props> = ({
  labelImageUrl,
  formValues,
  setValue,
  canSubmit,
  onSave,
  onClose,
}) => {
  const theme = useTheme()

  return (
    <Stack sx={{ height: '100%' }} aria-label="位置補正基準Form">
      <Stack spacing={2} p={3} overflow="auto" flexGrow={1}>
        <Typography variant="body1">
          画像の中で2点をクリックして四角形を作り、位置補正範囲を設定してください。（ラベルの全体や、検査箇所など）
        </Typography>
        <Stack
          sx={{
            bgcolor: 'background.paper',
            borderRadius: 1,
            p: 2,
            boxShadow: 1,
            maxWidth: 600,
            mx: 'auto',
            width: '100%',
          }}
        >
          <BBoxSelector
            labelImageUrl={labelImageUrl}
            otherBBoxes={[]}
            selectedBBox={{
              name: '位置補正基準',
              x: formValues.x,
              y: formValues.y,
              width: formValues.width,
              height: formValues.height,
            }}
            onBBoxChange={{
              setX: (x: number) => setValue('x', x),
              setY: (y: number) => setValue('y', y),
              setWidth: (w: number) => setValue('width', w),
              setHeight: (h: number) => setValue('height', h),
            }}
            color={theme.palette.primary.main}
            resizable={false}
          />
        </Stack>
      </Stack>

      <Stack
        direction="row"
        justifyContent="flex-end"
        spacing={1}
        sx={{ p: 2, borderTop: 1, borderColor: 'divider' }}
      >
        <Button variant="outlined" onClick={onClose}>
          キャンセル
        </Button>
        <Button variant="contained" onClick={onSave} disabled={!canSubmit}>
          確定
        </Button>
      </Stack>
    </Stack>
  )
}
